import React, { useState, Fragment } from "react";

import styled, { css } from "styled-components";

import {
  // FormFooter,
  ModalAlert,
  Input,
  FormGroup,
  // Modal,
  Button,
  StatusDot,
  ContentBlock,
  Tooltip,
  Card,
  Icon,
  Slider,
  Select,
  // Head,
  Checkbox,
  Textarea,
  ImagePicker
} from "xsolla-uikit";

import { xsollaProducts } from "../data/xsollaProducts";

import { Switch, Route, Link } from "react-router-dom";

import { PAsolutionCards } from "./cards/PAsolutionCards";
import PAslider from "./PAslider";
import { isStyledComponent } from "styled-components";
import { ProductIcon } from "../data/ProductIcon";
import {
  ButtonOutlineWhite,
  CSSonlyMob,
  CSSonlyWeb,
  CSSbigInput
} from "./uikit2";
import {
  microtransactionsSolutions,
  currencySolutions,
  subscriptionsSolutions,
  sitebuilderSolutions,
  gameStoreSolutions,
  launcherSolutions,
  loginSolutions,
  paystationSolutions,
  partnernetworkSolutions
} from "../data/defaultSolutions";
import PAh2 from "./PAh2";
import { PAchartKA } from "./dashboard/PAchartUsersMethods";


const mainFilters = [
  {
    label: "All stages",
    tooltip: "All solutions",
    value: "all"
  },
  {
    label: "Pre-launch",
    value: "before",
    tooltip: (
      <div>
        Show solutions for:
        <br />
        Pre-orders / crowdfunding (2)
        <br />
        Audience Gathering (3)
      </div>
    )
  },
  {
    label: "Early access",
    value: "launch",
    tooltip: (
      <div>
        Show solutions for:
        <br />
        Founder packs sales (2)
        <br />
        Audience Gathering (3)
        <br />
        Launch events (1)
      </div>
    )
  },
  {
    label: "Live game",
    value: "after",
    tooltip: (
      <div>
        Show solutions for:
        <br />
        Additional monetization (2)
        <br />
        Recurrent payments (3)
      </div>
    )
  }
]

const all = {
  cards: [
    ...microtransactionsSolutions,
    ...gameStoreSolutions,
    ...sitebuilderSolutions,
    // ...currencySolutions,
    ...subscriptionsSolutions,
    ...paystationSolutions,
    ...launcherSolutions,
    ...loginSolutions,
    ...partnernetworkSolutions
  ],
  product: "all",
  filters: [...mainFilters],
};

const bluePages = {
  microtransactions: {
    cards: microtransactionsSolutions,
    product: "microtransactions",
    // filters: [...mainFilters]
    filters: []
  },
  game_store: {
    cards: gameStoreSolutions,
    product: "game_store",
    // filters: [...mainFilters]
    filters: []
  },
  subscriptions: {
    cards: subscriptionsSolutions,
    product: "subscriptions",
    filters: []
  },
  // currency: {
  //   cards: currencySolutions,
  //   product: "currency",
  //   filters: []
  // },
  pay_station: {
    cards: paystationSolutions,
    product: "pay_station",
    filters: []
  },
  site_builder: {
    cards: sitebuilderSolutions,
    product: "site_builder",
    filters: []
  },
  launcher: {
    cards: launcherSolutions,
    product: "launcher",
    filters: []
  },
  login: {
    cards: loginSolutions,
    product: "login",
    filters: []
  },
  partner_network: {
    cards: partnernetworkSolutions,
    product: "partner_network",
    filters: []
  },

  all: {
    ...all
  }
};

export default function PAblue(props) {

  const {
    ka, //TODO:TEMP
    manyProjects, //TODO:TEMP
    product = "store",
    title,
    backUrl,
    hardlimit,
    limit,
    seeMore,
  } = {...props}

  return (
    <div className="">
      {!!backUrl && (
        <div
          style={{
            position: "absolute",
            zIndex: 1000,
            width: "100%",
            top: 0,
            padding: "20px"
          }}
        >
          <Link to={backUrl}>
            <ButtonOutlineWhite>
              <Button size="md" appearance="outline">
                <Icon name="chevron-reverse" />
              </Button>
            </ButtonOutlineWhite>
          </Link>
        </div>
      )}

      <PAbluePage
        manyProjects={manyProjects}
        {...bluePages[product]}
        title={title}
        hardlimit={hardlimit}
        limit={limit}
        key={`title_${title}`}
        seeMore={seeMore}
        {...props}
      />
    </div>
  );
}

const needsKA = [
  {
    value: "microtransactions",
    label: "Emergent live game",
    tooltip:
      "Emergent live games games tend to gradually grow in popularity. Most of Twitch’s biggest titles are emergent live games. Examples include PUBG, CS:GO, Rainbow Six Siege, and League of Legends."
  },
  {
    value: "premium",
    label: "Concentrated launch",
    tooltip:
      "Concentrated launches drive the bulk of sales narrowly around launch, reheating sales later in a game’s lifecycle. Example titles include Spider Man, Kingdom Come Deliverance, and Just Cause 3."
  },
  {
    value: "subscriptions",
    label: "Indie game",
    tooltip:
      "Successful indie games sales grow after launch, but traffic is less consistent than annual franchises or emergent live games. Examples include Dead Cells, Super Meat Boy, and Braid."
  },
  {
    value: "funding",
    label: "Annual franchise",
    tooltip:
      "Annual franchises tend to have both major launches and live service features to sustain play. Examples include NBA2K, FIFA, Madden, Battlefield, and Call Of Duty."
  }
];

const needs = [
  {
    value: "microtransactions",
    label: "Microtransactions"
  },
  {
    value: "premium",
    label: "Premium"
  },
  {
    value: "subscriptions",
    label: "Subscriptions"
  }
  // {
  //   value: 'funding',
  //   label: 'Funding',
  // }
];

const platforms = [
  {
    value: "win",
    label: "PC"
  },
  {
    value: "console",
    label: "Console"
  },
  {
    value: "mobile",
    label: "Mobile"
  },
  {
    value: "web",
    label: "Web"
  }
];

const allFilters = [...platforms, ...needs];

const platfDefault = [
  "win",
  "console",
  "mobile",
  "web",
  "microtransactions",
  "premium",
"subscriptions",
  "funding"
];

export function PAbluePage({
  ka,
  manyProjects,

  backUrl,
  product = "microtransactions",
  cards,
  hardlimit,
  filters = [],
  filter,
  title,
  limit,
  seeMore,
}) {
  // const needs = ka ? needsKA : needs;

  const [filt, setFilter] = useState(
    filters.length ? filters[1]["value"] : null
  );

  const [platf, setPlatf] = useState([...platfDefault]);

  const [filtNum, setFilterNum] = useState(filters ? 1 : null);

  const [filtNum2, setFilterNum2] = useState(needsKA ? 0 : null);

  // const [filtPlat, setFiltPlat] = useState([...platforms.map((pl)=> pl['value'])]);

  window["swiperHandle"] = ind => {
    if (typeof ind !== "undefined") setFilter(filters[ind]["value"]);
  };

  const filterCards = (filt, cards) => {
    if (cards.length && !cards[0]["tag"]) {
      return cards;
    }
    // debugger
    return cards.filter(
      (oneCard, ind) =>
        !filt || (oneCard["tag"] && oneCard["tag"].indexOf(filt) !== -1)
    );
  };

  const handlePlatform = v => {
    console.log("v = ", v);
    let p = [...platf];
    if (p.indexOf(v) === -1) {
      p = [...p, v];
    } else {
      p.splice(p.indexOf(v), 1);
    }
    console.log("p = ", p);
    setPlatf(p);
  };

  const checkIf = oneF => {
    let ret;
    filters.forEach(oneF => {
      ret = platf.indexOf(oneF) !== -1 ? true : false;
    });
    return ret;
  };

  return (
    <CSSmikeFix>
      <div
        className="xsui-content-block xsui-content-block--appearance-branding"
        style={{
          // padding: !title ? '44px 0' : '24px 32px',
          alignItems: "start",
          // height: !title ? "96vh" : "auto",
          // paddingTop: !!limit ? 24 : '10vh',
          backgroundPosition: "50% -100px",
          backgroundRepeat: "no-repeat",
          backgroundSize: "1103px 708px",
          backgroundRepeatY: "repeat",
          // height: '100vh',
          padding: 0
        }}
        appearance="branding"
      >
        <div
          style={{
            width: "100%",
            color: "black",
            textAlign: "left",
            height: "100%",
            // overflowY: "auto",
            // padding: !!limit ? 24 : '0 0 20vh 0',
            padding: (title) ? "24px 32px" : "0 32px 20vh 32px"
            // padding: '44px 0',
            // minHeight: !title ? '96vh' : 'none',
          }}
        >
          <div
            style={{
              padding: !!title ? "0 0 24px 0" : "80px 0 0 0"
            }}
          >
            {!!title && title}

            {/* <FormGroup>
              <p>Your game profile</p>

            </FormGroup> */}

            {!title && product !== "all" && (
              <FormGroup indentation="xs">
                <FormGroup indentation="xs">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center"
                    }}
                  >
                    <ProductIcon
                      // size="xs"
                      width={64}
                      height={64}
                      name={product}
                      color="white"
                    />
                  </div>
                </FormGroup>

                <FormGroup indentation="md">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center"
                    }}
                  >
                    <div className="product-start-page-title">
                      {xsollaProducts[product] && xsollaProducts[product]["name"]}
                    </div>
                    <div
                      // className="product-start-page-description"
                      style={{
                        maxWidth: 640,
                        marginBottom: 24,
                        color: "#fff",
                        textAlign: "center",
                        fontSize: 16,
                        lineHeight: '1.6em'
                      }}
                    >
                      {xsollaProducts[product]["defaultDescription"]}
                    </div>

                    {/* <Link to="/launcher/my_project"> */}
                    {/* <Link to="/launcher/new"></Link> */}
                  </div>
                </FormGroup>

                <br />
              </FormGroup>
            )}
          </div>

          {product === "all" && (
            <FormGroup indentation="md">
              {!title && (
                <div
                  className="l_flex"
                  style={{ justifyContent: "center", alignItems: "center" }}
                >
                  <div className="product-start-page-title">
                    Your top business recommendations from Xsolla
                  </div>
                </div>
              )}

              {!!manyProjects && (
                <div
                  className="l_flex"
                  style={{ justifyContent: "center", alignItems: "center" }}
                >
                  <span className="product-start-page-title">
                    Top business recommendations from Xsolla for
                  </span>

                  <div style={{ margin: "-20px 0 0 20px" }}>
                    <Select
                      align="right"
                      name=""
                      size="sm"
                      options={[
                        { label: "Project 1", value: 1 },
                        { label: "Project 2", value: 2 }
                      ]}
                      input={{
                        name: "widgTheme",
                        value: 1,
                        onChange: () => {
                          void 0;
                        }
                      }}
                    />
                  </div>
                </div>
              )}
            </FormGroup>
          )}

          {product === "all1" && (
            <FormGroup indentation="lg">
              <div className="l_flex" style={{ justifyContent: "center" }}>
                <CSSbigInput>
                  {/* <Input
                    input={{
                      name: "project name",
                      value: '',
                      // onChange: () => void 0
                    }}
                    placeholder="My game"
                    inline={true}
                    // disabled={true}
                    // focused={true}
                    size="sm"
                  /> */}

                  {/* <div>Game name:</div> */}

                  <input type="text" value="My game" />
                </CSSbigInput>
              </div>
              <br />
              <br />
            </FormGroup>
          )}

          {/* {!title && <FormGroup> */}

          {!title && !!filters.length && (
            <div
              style={{
                // position: "sticky",
                top: 0,
                zIndex: 100,
                // background: "#0073f7",
                padding: "0 0 24px 0"
              }}
            >
              {/* <h3>My game is</h3> */}

              <CSSonlyWeb>
                <div className="">
                  <FormGroup>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "white"
                      }}
                    >
                      {filters.map((oneF, index, filters) => (
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                          key={`filter_${index}`}
                        >
                          <div style={{ margin: "0 2em" }}>
                            <Tooltip label={oneF["tooltip"]}>
                              <Button
                                onClick={() => {
                                  setFilter(oneF["value"]);
                                  setFilterNum(index);
                                }}
                                style={{ color: "white" }}
                                style={{
                                  color: `${
                                    filt !== oneF["value"]
                                      ? "rgba(255,255,255,0.4)"
                                      : "#fff"
                                  }`,
                                  fontSize: 24
                                }}
                                appearance="flatten"
                                color="red"
                              >
                                {oneF["label"]}
                              </Button>
                            </Tooltip>
                          </div>

                          {/* {filters.length > (index + 1) && <span style={{opacity: 0.3}}><Icon name="chevron-mini"/></span>} */}
                        </div>
                      ))}
                    </div>
                  </FormGroup>

                  <br />

                  <FormGroup>
                    <CSSsolSlider0>
                      <CSSsolSlider>
                        <Slider
                          input={{
                            name: "slider",
                            min: 0,
                            max: filters.length - 1,
                            value: filtNum,
                            onChange: (nw, ind) => {
                              setFilter(filters[nw]["value"]);
                              setFilterNum(nw);
                            }
                          }}
                        />
                      </CSSsolSlider>
                    </CSSsolSlider0>
                    <br />
                    <br />
                  </FormGroup>
                </div>

                <FormGroup>
                  <div
                    style={{
                      display: "flex",
                      // flexDirection: 'column',
                      justifyContent: "center",
                      alignItems: "center",
                      color: "white",
                      fontSize: 18,
                      marginBottom: 16
                    }}
                  >
                    <div
                      style={{
                        marginTop: -6,
                        marginRight: 4,
                        opacity: 0.4
                      }}
                    >
                      Monetization:
                    </div>

                    {needs.map((oneF, index, filters) => (
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                        key={`filter_os_${index}`}
                      >
                        <span style={{ margin: "0 1em" }}>
                          <CSScheckbox18
                            style={{
                              opacity:
                                platf.indexOf(oneF["value"]) !== -1 ? 1 : 0.4
                            }}
                          >
                            <Checkbox
                              name={`check_${oneF["label"]}`}
                              label={oneF["label"]}
                              input={{
                                value:
                                  platf.indexOf(oneF["value"]) === -1
                                    ? false
                                    : true,
                                onChange: () => handlePlatform(oneF["value"])
                              }}
                            />
                          </CSScheckbox18>
                        </span>
                      </div>
                    ))}
                  </div>
                </FormGroup>

                <FormGroup>
                  <div
                    style={{
                      display: "flex",
                      // flexDirection: 'column',
                      justifyContent: "center",
                      alignItems: "center",
                      color: "white",
                      fontSize: 18
                    }}
                  >
                    <div
                      style={{
                        marginTop: -6,
                        marginRight: 4,
                        opacity: 0.4
                      }}
                    >
                      Platform:
                    </div>
                    {platforms.map((oneF, index, filters) => (
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                        key={`filter_os_${index}`}
                      >
                        <span style={{ margin: "0 1em" }}>
                          <CSScheckbox18
                            style={{
                              opacity:
                                platf.indexOf(oneF["value"]) !== -1 ? 1 : 0.4
                            }}
                          >
                            <Checkbox
                              name={`check_${oneF["label"]}`}
                              label={oneF["label"]}
                              input={{
                                value:
                                  platf.indexOf(oneF["value"]) === -1
                                    ? false
                                    : true,
                                onChange: () => handlePlatform(oneF["value"])
                              }}
                            />
                          </CSScheckbox18>
                        </span>
                      </div>
                    ))}
                  </div>
                </FormGroup>

                {ka && (
                  <FormGroup indentation="lg">
                    <CSSblueCharts>
                      <FormGroup indentation="xs">
                        <PAchartKA variant={filtNum2} />
                      </FormGroup>
                      <div style={{ color: "white", marginTop: -16 }}>
                        Expected sales graph
                      </div>
                    </CSSblueCharts>
                    <br />
                    <br />
                  </FormGroup>
                )}
              </CSSonlyWeb>

              <br />
              <br />

              <CSSonlyMob>
                <CSSsolSlider0>
                  <CSSsolSwiper>
                    <PAslider
                      handleActive={nw => {
                        setFilter(nw);
                        // setFilterNum(index)
                      }}
                    >
                      {filters.map((oneF, index, filters) => (
                        <CSSslide
                          className="swiper-slide"
                          key={`slide_${index}`}
                        >
                          <CSSslideInner>
                            {/* <span style={{margin: '0 1em'}}> */}
                            <Button
                              // onClick={()=>{
                              //   setFilter(oneF['value'])
                              //   setFilterNum(index)
                              // }}
                              style={{
                                color: `${
                                  filt !== oneF["value"]
                                    ? "rgba(255,255,255,0.4)"
                                    : "#fff"
                                }`,
                                fontSize: 18,
                                whiteSpace: "nowrap"
                              }}
                              appearance="flatten"
                              color="red"
                            >
                              {oneF["label"]}
                            </Button>
                            {/* </span> */}
                            {/* {filters.length > (index + 1) && <span style={{opacity: 0.3, color: 'white'}}><Icon name="chevron-mini"/></span>} */}
                          </CSSslideInner>
                        </CSSslide>
                      ))}
                    </PAslider>
                  </CSSsolSwiper>
                </CSSsolSlider0>
              </CSSonlyMob>
            </div>
          )}

          {/* </FormGroup>} */}

          <FormGroup indentation="lg">
            <PAsolutionCards
              limit={limit}
              hardlimit={hardlimit}
              platforms={platf}
              // size="sm" //TODO: отключение картинки
              // solutions={filterCards(filt, cards)}
              solutions={cards}
              filter={filt}
              appear={true}
            />

            {/* </div> */}
          </FormGroup>

          {seeMore && <div
          style={{
            // position: "absolute",
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
            width: "100%",
            top: 0,
            padding: "20px"
          }}
        >
          {xsollaProducts[product]['item'] && xsollaProducts[product]['item'].map(item => (
          <Fragment>
          <Link to={item['createUrl']}>
            <ButtonOutlineWhite>
              <Button size="md"
                // appearance="outline"
                appearance="flatten"
                style={{color: 'white'}}
                >
                {item['create']}
              </Button>
            </ButtonOutlineWhite>
          </Link>

          &nbsp;&nbsp;&nbsp;<span style={{color:'white'}}>|</span>&nbsp;&nbsp;&nbsp;</Fragment>))}

          <Link to='/start?filters=microtransactions,pc_mac,web,console,mobile,early_access,live_game,pre_launch'>
            <ButtonOutlineWhite>
              <Button size="md" appearance="flatten"
                style={{color: 'white'}}
              >
                See all solutions
              </Button>
            </ButtonOutlineWhite>
          </Link>
        </div>}

        </div>





      </div>

    </CSSmikeFix>
  );
}

const CSSblueCharts = styled.div`
  margin-top: -44px;
  width: 400px;
  /* height: 200px; */
  /* background: white; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* margin: 44px auto; */
  margin: 0 auto;
  & .highcharts-color-0 {
    fill: #f1f8ff;
    stroke: #0073f7;
  }
  & .highcharts-grid-line {
    fill: none;
    stroke: none;
  }
  & .highcharts-grid-line {
    fill: none;
    stroke: none;
  }
  & .highcharts-axis-labels {
    fill: none;
    stroke: none;
  }
  & .highcharts-axis-title {
    fill: none;
  }
`;

const CSSmikeFix = styled.div`
  & .xsui-content-block--appearance-branding {
    @media (max-width: 768px) {
      border-radius: 0;
      padding-top: 2vh;
    }
  }
`;

const CSSslide = styled.div`
  /* max-width: 300px; */
  transition: all 150ms ease-in-out;
  /* width: 400px; */
  display: flex;
  justify-content: center;
  height: 64px;
  cursor: pointer;
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  @media (max-width: 768px) {
    /* width: 280px; */
    /* max-width: 280px; */
    /* width: 280px; */
  }

  @media (max-width: 479px) {
    /* width: 280px; */
    /* max-width: auto; */
    /* max-width: 280px; */
    /* width: auto; */
  }
`;

const CSSslideInner = styled.div`
  /* width: 400px; */
  display: flex;
  justify-content: center;
  height: 64px;
  padding: 16px 24px;
`;

const CSSsolSlider0 = styled.div`
  margin-top: -16px;
  display: flex;
  align-items: center;
  justify-content: center;

  & .rc-slider-track,
  & .rc-slider-rail {
    background-color: #4199ff59;
  }
  & .rc-slider-handle {
    box-shadow: none;
  }
`;

const CSSsolSlider = styled.div`
  width: 500px;
`;

const CSSsolSwiper = styled.div`
  width: 100%;
  justify-self: stretch;
  @media (max-width: 768px) {
    position: fixed;
    top: 70vh;
    padding-bottom: 6vh;
    padding-top: 2vh;
    height: 30vh;
    background: #00244d;
    z-index: 10;
    display: flex;
    /* align-items: center; */
  }
`;
const CSScheckbox18 = styled.div`
  & .xsui-checkbox__label {
    font-size: 18px;
  }
  & .xsui-checkbox__label:after {
    width: 20px;
    height: 20px;
  }
  & .xsui-checkbox__label:not(:empty) {
    padding-left: 26px;
  }
  & .xsui-checkbox__label:after {
    width: 16px;
    height: 16px;
    position: absolute;
    top: 5px;
    left: 3px;
    width: 16px;
    height: 16px;
    box-sizing: border-box;
    border: 1px solid #ffffff00;
    background-color: #ffffff38;
  }
`;

export const CardFilters = ({
  filt,
  filters = [],
  setFilter = () => void 0,
  setFilterNum = () => void 0
}) => {
  return (
    <FormGroup>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: 16,
          justifyContent: "center"
        }}
      >
        {filters.map((oneF, index, filters) => (
          <div
            style={{ display: "flex", justifyContent: "center" }}
            key={`filter_${index}`}
          >
            <div style={{ margin: "0 1em" }}>
              <Tooltip label={oneF["tooltip"]}>
                <Button
                  onClick={() => {
                    setFilter(oneF["value"]);
                    setFilterNum(index);
                  }}
                  style={{ color: "white" }}
                  style={{
                    color: `${
                      filt !== oneF["value"] ? "rgba(0,0,0,0.4)" : "#000"
                    }`,
                    fontSize: 18
                  }}
                  appearance="flatten"
                  color="red"
                >
                  {oneF["label"]}
                </Button>
              </Tooltip>
            </div>
          </div>
        ))}
      </div>
    </FormGroup>
  );
};

export const CardFilters2 = ({
  needs = [],
  platf = [],
  handlePlatform = () => void 0
}) => {
  return (
    <FormGroup>
      <div
        style={{
          display: "flex",
          // flexDirection: 'column',
          justifyContent: "center",
          alignItems: "center",
          fontSize: 18,
          marginBottom: 16
        }}
      >
        <div
          style={{
            marginTop: -6,
            marginRight: 4,
            opacity: 0.4
          }}
        >
          My game needs:
        </div>

        {needs.map((oneF, index, filters) => (
          <div
            style={{ display: "flex", justifyContent: "center" }}
            key={`filter_os_${index}`}
          >
            <span style={{ margin: "0 1em" }}>
              <CSScheckbox18
                style={{
                  opacity: platf.indexOf(oneF["value"]) !== -1 ? 1 : 0.4
                }}
              >
                <Checkbox
                  name={`check_${oneF["label"]}`}
                  label={oneF["label"]}
                  input={{
                    value: platf.indexOf(oneF["value"]) === -1 ? false : true,
                    onChange: () => handlePlatform(oneF["value"])
                  }}
                />
              </CSScheckbox18>
            </span>
          </div>
        ))}
      </div>
    </FormGroup>
  );
};

export const CardFilters3 = ({
  needs = [],
  platf = [],
  handlePlatform = () => void 0
}) => {
  return (
    <FormGroup>
      <div
        style={{
          display: "flex",
          // flexDirection: 'column',
          justifyContent: "center",
          alignItems: "center",
          fontSize: 18
        }}
      >
        <div
          style={{
            marginTop: -6,
            marginRight: 4,
            opacity: 0.4
          }}
        >
          My game is for:
        </div>

        {platforms.map((oneF, index, filters) => (
          <div
            style={{ display: "flex", justifyContent: "center" }}
            key={`filter_os_${index}`}
          >
            <span style={{ margin: "0 1em" }}>
              <CSScheckbox18
                style={{
                  opacity: platf.indexOf(oneF["value"]) !== -1 ? 1 : 0.4
                }}
              >
                <Checkbox
                  name={`check_${oneF["label"]}`}
                  label={oneF["label"]}
                  input={{
                    value: platf.indexOf(oneF["value"]) === -1 ? false : true,
                    onChange: () => handlePlatform(oneF["value"])
                  }}
                />
              </CSScheckbox18>
            </span>
          </div>
        ))}
      </div>
    </FormGroup>
  );
};
